<template>
    <item :title="title" :subTitle="subtitle" iconClass="ogc-icon-youxiang" :isActive="isActive">
        <template slot="buttons">
            <el-button class="button" type="primary" round plain @click="onShow">{{ button }}</el-button>
        </template>

        <fc-dialog :title="button" :visible.sync="visible" v-if="phone != null">

            <div>
                <el-steps :active="templateIndex" finish-status="success" align-center>
                    <el-step title="认证方式"></el-step>
                    <el-step title="安全认证"></el-step>
                    <el-step :title="button"></el-step>
                </el-steps>
            </div>

            <template v-if="templateIndex == 0">
                <el-alert show-icon title="认证方式" 
                :description="step1Description" type="info" effect="dark"></el-alert>

                <div class="types">
                    <div class="type-item" :class="{ active: vtype == 0 }" @click="changeType(0)">
                        <div class="icon"><img src="/static/images/me/verify-by-phone.png" alt=""></div>
                        <h3>通过手机验证</h3>
                        <p>使用手机 {{ phone }} 验证</p>
                    </div>
                    <div class="type-item" :class="{ active: vtype == 1 }" @click="changeType(1)" v-if="canEmail">
                        <div class="icon"><img src="/static/images/me/verify-by-email.png" alt=""></div>
                        <h3>通过邮箱验证</h3>
                        <p>使用邮箱  {{ email }}  验证</p>
                    </div>
                </div>

            </template>
            <template v-if="templateIndex == 1">
                <el-alert show-icon title="现在进行安全认证" v-if="vtype == 0"
                description="我们刚刚发送了一条短信到您的手机上，请输入短信中的验证码。" type="warning" effect="dark"></el-alert>
                <el-alert show-icon title="现在进行安全认证" v-else
                description="我们刚刚发送了一封邮件到您的邮箱，请输入邮件中的六位验证码。" type="warning" effect="dark"></el-alert>
                
                <auto-form ref="form1" :rules="rules[1]" :form="form" :form-template="formTemplate[1]" :url="url.validateVCode"></auto-form>
            </template>
            <template v-if="templateIndex == 2">
                <el-alert show-icon title="恭喜！安全验证成功！" 
                description="请输入您的邮箱地址。" type="success" effect="dark"></el-alert>
                
                <auto-form ref="form2" :rules="rules[2]" :form="form" :form-template="formTemplate[2]" :url="url.save" beforeSave="beforeSave" @afterSaved="afterSaved"
                @saved="onSaved" :canEdit="true" :isEdit="false"></auto-form>
            </template>


            <div slot="footer" class="dialog-footer">
                <el-button type="warning" :disabled="uploading" plain @click="cancel"> 取 消 </el-button>
                <el-button type="primary" :disabled="uploading" @click="next" v-if="templateIndex < 2"> 下一步 </el-button>
                <el-button type="success" :disabled="uploading" @click="next" v-else> 确认绑定 </el-button>
            </div>
        </fc-dialog>
    </item>
</template>

<script type="text/javascript">

import AutoForm from '@/components/AutoForm'
import FcDialog from '@/components/Dialogs/Dialog'
import Item from './OptionItem'

export default {
    components: {
        Item, FcDialog, AutoForm
    },
    props: {
        phone: {
            type: String,
            default: null
        },
        email: {
            type: String,
            default: null
        },
        password: {
            type: Number,
            default: 0
        },
        username: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            visible: false,
            uploading: false,
            vtype: 0,
            form: { Password:'', RePassword:'', vcode:'', vcode1:'' },
            formTemplate: [
                [],
                [
                    { col: 24, tips: '安全认证', type: 'tips' },
                    { col: 24, label: '短信验证码', prop: 'vcode1' },
                ],
                [
                    { col: 24, tips: '绑定邮箱', type: 'tips' },
                    { col: 24, label: '新邮箱地址', prop: 'Email' },
                    { col: 24, label: '验证码', prop: 'Captcha', type: 'captcha' },
                    { col: 24, label: '邮箱验证码', prop: 'vcode', type: 'v-code', click: (c) => { this.sendVcode(c); } },
                ]
            ],
            rules: [
              {},
              {
                vcode1: [
                  {
                    required: true,
                    message: '请输入短信验证码',
                    trigger: 'blur'
                  },
                  {
                    min: 6,
                    max: 6,
                    message: '验证码长度应为为 6 位',
                    trigger: 'blur'
                  }
                ]
              },
              {
                Email: [
                  {
                    required: true,
                    message: '请输入新邮箱地址',
                    trigger: 'blur'
                  },
                  {
                    validator: validateEmail,
                    trigger: 'blur'
                  }
                ],
                Captcha: [{ required: true, message: '请输入验证码', trigger: 'blur' }],
                vcode: [
                  {
                    required: true,
                    message: '请输入邮箱验证码',
                    trigger: 'blur'
                  },
                  {
                    min: 6,
                    max: 6,
                    message: '验证码长度应为为 6 位',
                    trigger: 'blur'
                  }
                ]
              }
            ],
            url: {
                validateVCode: SZH.assets.api + "/Authen/VerifyCodeForEmail",
                save: SZH.assets.api + "/Authen/SaveNewEmail",
                sendVCode: SZH.assets.api + "/Authen/SendEmailCode",
                sendPhoneVCodeOld: SZH.assets.api + "/Authen/SendVerifyCode2",
                sendEmailVCodeOld: SZH.assets.api + "/Authen/SendEmailCode2",
            },
            templateIndex: 0,
            sendOk: false
        }
    },
    methods: {
        next() {
            var self = this;
            if(self.templateIndex == 0) {
                if(self.vtype == 0) {
                    self.sendPhoneVCodeOld();
                }
                else {
                    self.sendEmailVCodeOld();
                }
            }
            else if(self.templateIndex == 1) {
                self.verify();
            }
            else {
                self.save();
            }
        },
        sendVcode(collback) {
            var self = this;
            var state = false;
            self.$refs['form2'].validateField(['Email', 'Captcha'], e1 => {
                if(e1 == null || e1 == '') {
                    state = true;
                }
                else {
                    return false;
                }
            });
            if(state) {
                self.uploading = true;

                self.$http.post(self.url.sendVCode, { 
                    ToEmail: self.form.Email,
                    Captcha: self.form.Captcha,
                    Template: 5
                }).then(result => { 
                    if (result.State == 1) {
                        self.sendOk = true;
                        self.$message.success("验证码已发送到您的新邮箱，请查看！");
                        collback();
                    } else {
                        self.$message.error(result.Message);
                        self.$refs['form2'].refreshCaptcha();
                    }
                    self.uploading = false;
                }, () => { 
                    self.uploading = false;
                });
            }

        },
        sendPhoneVCodeOld() {
            var self = this;
            self.uploading = true;
            self.$http.post(self.url.sendPhoneVCodeOld, { 
                Template: 4
            }).then(result => { 
                if (result.State == 1) {
                    self.sendOk = true;
                    self.$message.success("验证码发送成功！");
                    self.templateIndex++;
                } else {
                    self.$message.error(result.Message);
                }
                self.uploading = false;
            }, () => { 
                self.uploading = false;
            });
        },
        sendEmailVCodeOld() {
            var self = this;
            self.uploading = true;
            self.$http.post(self.url.sendEmailVCodeOld, { 
                Template: 4
            }).then(result => { 
                if (result.State == 1) {
                    self.sendOk = true;
                    self.$message.success("验证码发送成功！");
                    self.templateIndex++;
                } else {
                    self.$message.error(result.Message);
                }
                self.uploading = false;
            }, () => { 
                self.uploading = false;
            });
        },
        verify() {
            var self = this;
            self.$refs['form1'].validate(valid => {
                if (valid) {
                    self.uploading = true;
                    self.$http.post(self.url.validateVCode, { 
                        Data: {
                            VCode: self.form.vcode1
                        }
                    }).then(result => { 
                       if (result.State == 1) {
                            self.$message.success("验证成功！");
                            self.form.vcode = '';
                            self.templateIndex++;
                        } else {
                            self.$message.error(result.Message);
                        }
                        self.uploading = false;
                    }, () => { 
                        self.uploading = false;
                    });
                }
                else {
                    return false;
                }
            });
        },
        save() {
            this.$refs['form2'].submit();
        },
        beforeSave() {
            this.loading = true;
        },
        afterSaved() {            
            this.loading = false;
        },
        onSaved() {
            this.$message.success("邮箱修改成功");
            this.visible = false;
            this.$emit('saved');
        },
        onShow() {
            this.visible = true;
        },
        cancel() {
            this.visible = false;
        },
        changeType(val) {
            this.vtype = val;
        }
    },
    computed: {
        title() {
            return this.email == null ? '邮箱未绑定' : this.email;
        },
        button() {
            return this.email == null ? '绑定邮箱' : '修改邮箱';
        },
        subtitle() {
            return this.email == null ? '绑定邮箱后，您可以使用邮箱来保障您的帐号安全' : '您可以使用邮箱来保障您的帐号安全';
        },
        isActive() {
            return this.email != null;
        },
        step1Description() {
            return '您正在为帐号 ' + this.username + ' 修改邮箱，请选择身份验证方式'
        },
        canEmail() {
            return this.email != null;
        }
    },
    created() {
    },
    mounted() {

    },
    watch: {
        visible(val) {
            if(val) {
                this.templateIndex = 0;
                for(var i in this.form) {
                    this.form[i] = '';
                }
            }
        }
    }
}
</script>

<style type="text/css" scoped>

.button {
    padding: 5px 10px;
}

.types {
    overflow: hidden;
    margin-top: 30px;
}

.type-item {
    width: calc(50% - 20px);
    border: 1px solid #CCC;
    padding: 30px 10px;
    text-align: center;
    float: left;
    cursor: pointer;
}
.type-item + .type-item {
    float: right;
}
.type-item:only-child {
    float: none;
    margin:0 auto;
}

.type-item.active {
    border: 3px solid #0A529C;
}

.type-item > .icon {
    height: 150px;
    line-height: 150px;
}
.type-item:last-child > .icon {
    padding-top: 20px;
}

.type-item > h3 {
    font-weight: 700;
    line-height: 30px;
}

</style>



// WEBPACK FOOTER //
// src/views/Me/Info/components/ChangeEmail.vue